import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { IUser } from 'src/app/core/models/user.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { FrameService } from 'src/app/core/services/frame.service';

@Component({
  selector: 'app-frames-list',
  templateUrl: './frames-list.component.html',
  styleUrls: ['./frames-list.component.css'],
})
export class FramesListComponent implements OnInit {
  @Input() darkMode: boolean;
  @Input() role: string;
  @Input() userId: string;
  @Input() clientId: string;
  @Input() customerId: string;
  @Output() reloadFrames = new EventEmitter();

  private dialogOptions: NgbModalOptions = {
    backdropClass: 'dark-backdrop',
    centered: true,
    windowClass: 'window-modal',
  };

  urlParams: string;

  addedFrames: any;
  availableFrames: any;

  searchParam: string;
  framesSearch: any;
  searchParamAll: string;
  framesSearchAll: any;
  showMyContainer = false;
  selectedFrame: any = 'Select frames...';
  selectedFrames: any;
  selectedFramesFilter: any;
  framesToChanged: any;

  frames: any;

  toggleAddLogo = false;

  isUploading = false;
  uploading = false;
  status = false;

  frameModal: any;

  toggleAddFrame = false;

  frameFile: any;
  frameFileModal: any;

  frame = { id: '', name: '', configuration: undefined };

  page = 1;
  perPage = 16;

  currentUser: IUser;

  constructor(
    private frameService: FrameService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    public router: Router,
    public route: ActivatedRoute,
    private authService: AuthService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.translate.get(['global.selectFrame']).subscribe((values) => {
      this.selectedFrame = values['global.selectFrame'];
    });
    this.authService.LoggedinUser.subscribe(
      user => {
        this.currentUser = user;
      }
    );
    this.route.queryParams.subscribe((queryParams: any) => {
      this.urlParams = queryParams;
    });
    this.loadFrames();
  }

  initializeFrames(frames: any, variableName: string) {
    frames.forEach((frame) => {
      frame.preview = null;
      if (frame.frameFiles) {
        frame.frameFiles.forEach((file) => {
          if (file.key === 'preview') {
            frame.preview = file.fileInfo.path;
          }
        });
      }
    });
    switch (variableName) {
      case 'addedFrames':
        this.addedFrames = frames;
        this.framesSearchAll = frames;
        break;
      case 'availableFrames':
        this.availableFrames = frames;
        break;
      default:
        break;
    }
  }

  loadFrames() {
    let getFrame$ = new Observable();
    let getAvailableFrames$ = new Observable();

    switch (this.role) {
      case 'root':
        getFrame$ = this.frameService.getFrames();
        break;
      case 'customer':
        if (this.currentUser.role.name === 'root') {
          getFrame$ = this.frameService.getCustomerFrames(this.customerId);
          getAvailableFrames$ = this.frameService.getFrames();
         } else {
          getFrame$ = this.frameService.getCustomerFrames(
            this.customerId
          );
          getAvailableFrames$ =
            this.frameService.getCustomerFrames(this.currentUser.customerId);
        }
        break;
      case 'client':
        getFrame$ = this.frameService.getClientFrames(this.clientId);
        getAvailableFrames$ = this.frameService.getCustomerFrames(
          this.customerId
        );
        break;
      case 'user':
        getFrame$ = this.frameService.getUserFrames(this.userId);
        getAvailableFrames$ = this.frameService.getClientFrames(this.clientId);
        break;
      default:
        break;
    }

    getFrame$.subscribe((frames) => {
      this.initializeFrames(frames, 'addedFrames');
    });

    if (getAvailableFrames$) {
      getAvailableFrames$.subscribe((frames) => {
        this.initializeFrames(frames, 'availableFrames');
      });
    }
  }

  openDropdown() {
    this.showMyContainer = !this.showMyContainer;
    this.searchParam = '';
    this.framesSearch = this.availableFrames;
  }

  applyFilter() {
    this.framesSearch = this.availableFrames.filter((frame) =>
      frame.name.toLowerCase().includes(this.searchParam.toLowerCase())
    );
  }

  applyFilterAddedFrames() {
    this.framesSearchAll = this.addedFrames.filter((frame) =>
      frame.name.toLowerCase().includes(this.searchParamAll.toLowerCase())
    );
  }

  clearSearch() {
    if (this.searchParamAll !== '') {
      this.searchParamAll = '';
      this.applyFilterAddedFrames();
    }
  }

  addFrame(frameId: string) {
    const isAssigned = this.addedFrames?.some((frame) => frame.id === frameId);
    if (isAssigned) {
      this.translate.get('errors.frameIsAlreadyAdded').subscribe((text: string) => {
        this.toastr.error(text);
      });
      return;
    }
    let addFrame$ = new Observable();
    switch (this.role) {
      case 'customer':
        addFrame$ = this.frameService.addFrameToCustomer(
          this.customerId,
          frameId
        );
        break;
      case 'client':
        addFrame$ = this.frameService.addFrameToClient(this.clientId, frameId);
        break;
      case 'user':
        addFrame$ = this.frameService.addFrameToUser(this.userId, frameId);
        break;
      default:
        break;
    }
    addFrame$.subscribe((res) => {
      this.loadFrames();
      this.reloadFrames.emit();
      this.showMyContainer = !this.showMyContainer;
      this.toastr.success('Successfully added frame.');
    });
  }

  openFrameModal(content, frame: any) {
    this.framesToChanged = frame;
    this.frameModal = this.modalService.open(content, this.dialogOptions);
  }

  showDialogAddFrame(content) {
    this.frameModal = this.modalService.open(content, this.dialogOptions);
    this.frameModal.result.then(
      (result) => {},
      (reason) => {
        this.frame = { id: '', name: '', configuration: undefined };
      }
    );
  }

  convertToJSON() {
    const ugly = (
      document.getElementById('json-textArea') as HTMLTextAreaElement
    ).value;
    const obj = JSON.parse(ugly);
    const pretty = JSON.stringify(obj, undefined, 4);
    (document.getElementById('json-textArea') as HTMLTextAreaElement).value =
      pretty;
  }

  createFrame(form) {
    console.log(form.form.value.conf.replace(/\s/g, ''));
    console.log(JSON.parse(form.form.value.conf.replace(/\s/g, '')));
    const conf = JSON.parse(form.form.value.conf.replace(/\s/g, ''));
    const body = {
      name: form.form.value.name,
      configuration: conf,
    };

    let createFrame$ = new Observable();

    switch (this.role) {
      case 'root':
        createFrame$ = this.frameService.addFrame(body);
        break;
      case 'customer':
        createFrame$ = this.frameService.createFrameByCustomer(
          this.customerId,
          body
        );
        break;
      case 'client':
        createFrame$ = this.frameService.createFrameByClient(
          this.clientId,
          body
        );
        break;
      case 'user':
        createFrame$ = this.frameService.createFrameByUser(this.userId, body);
        break;
      default:
        break;
    }

    createFrame$.subscribe(
      (res) => {
        this.toastr.success('Frame added');
        this.loadFrames();
        this.reloadFrames.emit();
      },
      (err) => {
        this.toastr.success('Something wrong');
      }
    );

    this.frameModal.close();
  }

  openAddFrameFile(content) {
    this.frameFileModal = this.modalService.open(content, this.dialogOptions);
  }

  getFrameFile(event) {
    this.frameFile = event.target.files[0];
  }

  sendFrameFile(form) {
    if (!this.frameFile) {
      this.translate.get('errors.noFileSelected').subscribe((text: string) => {
        this.toastr.error(text);
      });
      return;
    }
    const formData: FormData = new FormData();
    formData.append('frameFile', this.frameFile);
    formData.append('key', form.form.value.key);

    console.log(formData);

    this.frameService.addFrameFile(this.framesToChanged.id, formData).subscribe(
      (res) => {
        this.toastr.success('File uploaded.');
        this.loadFrames();
      },
      (err) => {}
    );
    this.frameFileModal.close();
    this.frameModal.close();
  }

  deleteFrameFile(file) {
    this.frameService.deleteFrameFile(file.frameId, file.fileInfo.id).subscribe(
      (res) => {
        this.toastr.success('File deleted.');
        this.loadFrames();
      },
      (err) => {}
    );
    this.frameModal.close();
  }

  deleteFrame(frame) {
    let deleteFrame$ = this.frameService.deleteFrame(frame.id);

    switch (this.role) {
      case 'root':
        deleteFrame$ = this.frameService.deleteFrame(frame.id);
        break;
      case 'customer':
        deleteFrame$ = this.frameService.deleteFrameFromCustomer(
          this.customerId,
          frame.id
        );
        break;
      case 'client':
        deleteFrame$ = this.frameService.deleteFrameFromClient(
          this.clientId,
          frame.id
        );
        break;
      case 'user':
        deleteFrame$ = this.frameService.deleteFrameFromUser(
          this.userId,
          frame.id
        );
        break;
      default:
        break;
    }

    deleteFrame$.subscribe(
      (res) => {
        this.toastr.success('Frame deleted.');
        this.loadFrames();
        this.reloadFrames.emit();
      },
      (err) => {}
    );
    this.frameModal.close();
  }

  onEdit(form) {
    const conf = JSON.parse(form.form.value.conf.replace(/\s/g, ''));
    const body = {
      name: form.form.value.name,
      configuration: conf,
    };
    this.frameService.editFrame(this.frame.id, body).subscribe(
      (res) => {
        this.toastr.success('Frame updated');
        this.loadFrames();
        this.reloadFrames.emit();
      },
      (err) => {}
    );
    this.frameModal.close();
  }

  editFrame(content, frame) {
    this.frame = frame;
    this.frameModal = this.modalService.open(content, this.dialogOptions);
    this.frameModal.result.then(
      (result) => {},
      (reason) => {
        this.frame = { id: '', name: '', configuration: undefined };
      }
    );
  }

  jumpToPage(event: any) {
    this.page = event;
  }
}
